type SearchableServiceRequest = {
    requestReference?: unknown;
    organizationName?: unknown;
    serviceName?: unknown;
    serviceCode?: unknown;
    requesterName?: unknown;
    requesterEmail?: unknown;
    consultantName?: unknown;
    focusRegionCountry?: unknown;
    priority?: unknown;
    status?: unknown;
    description?: unknown;
};

const normalize = (value: unknown) => String(value ?? '').toLowerCase()
    .replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();

export function serviceRequestMatchesSearch(request: SearchableServiceRequest, query: string): boolean {
    const terms = normalize(query).split(' ').filter(Boolean);
    if (!terms.length)
        return true;
    const searchable = normalize([
        request.requestReference,
        request.organizationName,
        request.serviceName,
        request.serviceCode,
        request.requesterName,
        request.requesterEmail,
        request.consultantName,
        request.focusRegionCountry,
        request.priority,
        request.status,
        request.description,
    ].join(' '));
    return terms.every(term => searchable.includes(term));
}
